import { Routes } from '@angular/router';

export const WpRouting: Routes = [
  {
    path: ''
    // component:
  }
];
